import produce from "immer";
import find from "lodash/find";
import { CustomizationState } from "../";
import { ContentEditableText, ContentPage } from "../../../types/customization/content";
import {
  findEditableTextDefinition,
  findFontDefinition,
  findPage,
  findPageDefinition,
} from "../../../utils/customization/finders";
import { calcTextProperties, constrainText } from "../../../utils/customization/text";
import { changeEditableTextElementContent } from "./changeEditableTextElementContent";

export interface ChangeEditableTextElementFontAction {
  type: "changeEditableTextElementFont";
  pageKey: string;
  editableTextKey: string;
  fontKey: string;
}

export function changeEditableTextElementFont(
  state: CustomizationState,
  action: ChangeEditableTextElementFontAction
): CustomizationState {
  return produce(state, (draftState) => {
    const { editableTextKey, fontKey, pageKey } = action;

    const page = findPage(pageKey, draftState.content);

    const element: ContentEditableText | undefined = find(
      page.editableTexts,
      (editableText) => editableText.editableTextKey === editableTextKey
    );
    if (element) {
      element.fontKey = fontKey;

      const pageDefinition = findPageDefinition(page.pageDefinitionKey, draftState.template);
      const elementDefinition = findEditableTextDefinition(editableTextKey, pageDefinition);
      const fontDefinition = findFontDefinition(element.fontKey, draftState.template);
      const { maxCharsPerLine, maxLines } = calcTextProperties(elementDefinition, fontDefinition);
      changeEditableTextElementContent(state, {
        content: constrainText(element.content, maxLines, maxCharsPerLine, ""),
        editableTextKey,
        pageKey,
        type: "changeEditableTextElementContent",
      });
    } else {
      draftState.ui.defaultFontKey = fontKey;
    }
  });
}

export function changeElementFontKey(
  state: CustomizationState,
  draftState: CustomizationState,
  fontKey: string,
  page: ContentPage,
  element: ContentEditableText | undefined
): void {
  if (element) {
    element.fontKey = fontKey;
    const editableTextKey = element.editableTextKey;

    const pageDefinition = findPageDefinition(page.pageDefinitionKey, draftState.template);
    const elementDefinition = findEditableTextDefinition(editableTextKey, pageDefinition);
    const fontDefinition = findFontDefinition(element.fontKey, draftState.template);
    const { maxCharsPerLine, maxLines } = calcTextProperties(elementDefinition, fontDefinition);
    changeEditableTextElementContent(state, {
      content: constrainText(element.content, maxLines, maxCharsPerLine, ""),
      editableTextKey,
      pageKey: page.key,
      type: "changeEditableTextElementContent",
    });
  } else {
    draftState.ui.defaultFontKey = fontKey;
  }
}
